import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as handlers from "../../../../constants/handlers";
import * as navigationActions from "../../../../actions/navigationActions";
import * as mainTabActions from "../../../../actions/mainTabActions";
import * as modelHelper from "../../../../helpers/modelHelper";

import CompetitiveColorsPanel from "../../../global/CompetitiveColorsPanel";

import imgLoad from "../../../../resources/img/svgicons/load-formula.svg";
import Modal from "../../../global/generic/Modal";
import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";

class CheaperColorsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedProduct: null,
            selectedFandeck: null,
            selectedColor: null
        };
    }

    componentDidMount = () => {
        this.setState({
            selectedProduct: this.props.params.product
        });
    };

    selectProduct = (product) => {
        this.setState({selectedProduct: product});
    };

    selectFandeckAndColor = (fandeck, color) => {
        this.setState({selectedFandeck: fandeck, selectedColor: color});
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleLoadButtonClick = () => {
        if (this.state.selectedColor !== null) {
            this.props.dispatchSelectFormulaAction(
                this.state.selectedColor,
                this.state.selectedProduct,
                this.state.selectedFandeck
            );

            this.props.dispatchCloseModalAction();
        }
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <div className="col-12 flex flex-align-center-vertical">
                <span className="align-left">
                    <span className="color-primary">
                        <Translate value="general.package" />:
                    </span>{" "}
                    {this.props.params.package.displayName}
                </span>
                <div className="flex">
                    <Button
                        tooltipText={!this.state.selectedColor ? translate("mainTab.noFormulaSelected") : null}
                        disabled={!this.state.selectedColor}
                        className="margin-right-5"
                        label={translate("general.loadFormula")}
                        onClick={this.handleLoadButtonClick}
                        svgBefore={imgLoad}
                    />
                    <CancelButton onClick={this.handleCloseModalClick} />
                </div>
            </div>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="mainTab.searchForCheaper" />)}
                content={modelHelper.buildModalSection(
                    <CompetitiveColorsPanel
                        tabId={this.props.tabId}
                        compFandeckId={this.props.params.fandeck === null ? null : this.props.params.fandeck.id}
                        compColorId={this.props.params.color === null ? null : this.props.params.color.id}
                        productId={this.props.params.product === null ? null : this.props.params.product.id}
                        fandeckId={null}
                        originalRgb={this.props.params.color === null ? null : this.props.params.color.rgb}
                        method={handlers.RELOAD_CLOSEST_COLOR_WITH_PRICES}
                        bipp={this.props.params.package}
                        margin={this.props.params.margin}
                        filtering={true}
                        pricing={true}
                        colorList={this.props.params.colorList}
                        selectProduct={this.selectProduct}
                        selectFandeckAndColor={this.selectFandeckAndColor}
                        reloadColorList={this.props.dispatchReloadClosestColorsWithPricesAction}
                        loadFormula={this.handleLoadButtonClick}
                    />
                )}
                footer={this.getFooter()}
                styles={{width: "85%"}}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CHEAPER_COLORS_MODAL));
        },
        dispatchSelectFormulaAction: (color, product, fandeck) => {
            dispatch(navigationActions.selectFormula(color, product, fandeck, null));
        },
        dispatchReloadClosestColorsWithPricesAction: (
            tabId,
            compFandeckId,
            compColorId,
            productId,
            fandeckId,
            deltaE,
            limit,
            bipp,
            margin
        ) => {
            dispatch(
                mainTabActions.reloadClosestColorsWithPrices(
                    tabId,
                    compFandeckId,
                    compColorId,
                    productId,
                    fandeckId,
                    deltaE,
                    limit,
                    bipp,
                    margin
                )
            );
        }
    };
};

export default CheaperColorsModal = connect(mapStoreToProps, mapDispatchToProps)(CheaperColorsModal);
